import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AuthLayout, AuthField, AuthError, SubmitButton, GoogleButton, Notice, useSubmitState } from "@/components/auth/AuthParts";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { error, loading, submit } = useSubmitState(async () => {
    await login(email, password);
    navigate(location.state?.from || "/dashboard");
  });

  const footer = <>No account? <Link to="/register" data-testid="register-link" className="link-blue">Sign up →</Link></>;

  return (
    <AuthLayout title="Log In" testId="login-page" footer={footer}>
      <form onSubmit={submit} className="mt-6 border-2 border-black p-6 space-y-4 bg-white hard-shadow">
        {location.state?.notice && <Notice testId="login-notice">{location.state.notice}</Notice>}
        <AuthField label="Email" testId="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <AuthField label="Password" testId="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <div className="text-right -mt-2">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="font-mono-data text-xs uppercase link-blue">Forgot password?</Link>
        </div>
        <AuthError testId="login-error" message={error} />
        <SubmitButton testId="login-submit" loading={loading}>Sign In</SubmitButton>
        <GoogleButton testId="google-login-btn" />
      </form>
    </AuthLayout>
  );
}
